import React from "react";
import List from "../../shared/List";
import helpers from "../../shared/helpers";
import config from "../../config";
import Popup from "../../shared/Popup";
import Form from "../../shared/Form";
import {ajaxPOST,ajaxGET} from "../../ajax";
import {eventLink} from "../Events/helpers";


export default function JobPromoList({type,slug,title,limit}){
  const [focusItem,setFocusItem] = React.useState(false);

  return (<>


<Popup
      show={focusItem}
      hide={()=>{ setFocusItem(false); }}
      style={{width:"850px",maxWidth:"100%"}}
    > 
      <div className="details">
        <h4>Usage for <span style={{textTransform:"uppercase"}}>{focusItem[0]?.promoCode.toLowerCase()}</span></h4>
        <b>Used {focusItem.length} time{focusItem.length !== 1 ? `s` : ``}</b>
        <table>
          {focusItem && focusItem.map((line,i)=>{
            return (<tr key={`promoDetails${i}`}>
              <th>{line.businessName}: {line.jobTitle}</th>
              <td>{line.billingEmail}</td>
              <td>{helpers.date(line.timeAdded)}</td>

            </tr>)
          })}
      </table>


      </div>

    </Popup>

    <List
      title={title}
      limit={limit}
      
      urlGET={`${config.promoCodes.JOBS_API}/${type}`}
      template={(i,index)=>{
        
        if(type == "available"){
          return (
            <tr key={`item${index}`}>
              <th style={{textDecoration:"underline"}}>{i.promocode || i.promoCode}</th>
              <td>{i.description}</td>
              <td>{i.discount} Discount</td>
            </tr>
          );
        }
        else{
          var promoCount = i.length;
          
          return (
            <tr key={`item${index}`} onClick={()=>{
              setFocusItem([...i].sort((a, b) => new Date(b.timeAdded) - new Date(a.timeAdded)));
            }}>


              <th style={{textDecoration:"underline"}}>{i[0].promoCode}</th>
              <td>Used {promoCount} time{promoCount !== 1 ? `s` : ``}</td>
              
            </tr>
          );
        }
      }}
    />
  </>);
}
